import styled from 'styled-components';
import { SidoList } from '../search/FilterData';

const RegionList = [
  { name: '전체' },
  { name: '서울' },
  { name: '의정부' },
  { name: '인천' },
  { name: '수원' },
  { name: '춘천' },
  { name: '청주' },
  { name: '대전' },
  { name: '대구' },
  { name: '부산' },
  { name: '울산' },
  { name: '창원' },
  { name: '광주' },
  { name: '전주' },
  { name: '제주' },
];

const RegionList2 = [
  { name: '서울' },
  { name: '의정부' },
  { name: '인천' },
  { name: '수원' },
  { name: '춘천' },
  { name: '청주' },
  { name: '대전' },
  { name: '대구' },
  { name: '부산' },
  { name: '울산' },
  { name: '창원' },
  { name: '광주' },
  { name: '전주' },
  { name: '제주' },
];

interface IProps {
  regionTab: string;
  setRegionTab: (value: string) => void;
  tabNumber: number;
}

const RegionTab = ({ regionTab, setRegionTab, tabNumber }: IProps) => {
  const List =
    tabNumber === 1 ? RegionList : tabNumber === 2 ? RegionList2 : RegionList2;
  return (
    <RegionTabBox>
      {List.map((item, index) => (
        <div style={{ flex: 1, position: 'relative' }} key={index}>
          <Tab
            active={regionTab === item.name}
            onClick={() => setRegionTab(item.name)}
          >
            {item.name}
          </Tab>
        </div>
      ))}
    </RegionTabBox>
  );
};

export default RegionTab;

interface IProps2 {
  regionTab: string;
  setRegionTab: (value: string) => void;
  tabNumber: number;
}

export const RegionTab2 = ({ regionTab, setRegionTab }: IProps2) => {
  const List = SidoList;
  return (
    <RegionTabBox>
      {List.map((item, index) => (
        <div style={{ flex: 1, position: 'relative' }} key={index}>
          <Tab
            active={regionTab === item.region}
            onClick={() => {
              setRegionTab(item.region);
            }}
          >
            {item.region}
          </Tab>
        </div>
      ))}
    </RegionTabBox>
  );
};

interface IRegionTab {
  active: boolean;
}

const RegionTabBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 6px;
  overflow-x: auto;
  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
`;

const Tab = styled.span<IRegionTab>`
  width: 100%;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 18.85px;
  word-wrap: break-word;
  color: white;
  color: ${({ active }) => (active ? '#fff' : '#989BA2')};
  border-radius: 9999px;
  cursor: pointer;
  background-color: ${({ active }) =>
    active ? '#222222' : 'rgba(112, 115, 124, 0.08)'};
  white-space: nowrap;
`;
